import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export const DropdownMenu = DropdownMenuPrimitive.Root;
export const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;

export function DropdownMenuContent({ children, className, align = 'end' }: {
  children: ReactNode; className?: string; align?: 'start' | 'center' | 'end';
}) {
  return (
    <DropdownMenuPrimitive.Portal>
      <DropdownMenuPrimitive.Content
        align={align}
        sideOffset={6}
        className={cn('z-50 min-w-48 overflow-hidden rounded-lg border border-border bg-card p-1 shadow-lift animate-fade-in', className)}
      >
        {children}
      </DropdownMenuPrimitive.Content>
    </DropdownMenuPrimitive.Portal>
  );
}

export function DropdownMenuItem({ children, onSelect, className, disabled }: {
  children: ReactNode; onSelect?: () => void; className?: string; disabled?: boolean;
}) {
  return (
    <DropdownMenuPrimitive.Item
      disabled={disabled}
      onSelect={onSelect}
      className={cn('flex cursor-pointer select-none items-center gap-2 rounded-md px-2.5 py-2 text-xs outline-none transition data-[highlighted]:bg-muted data-[disabled]:pointer-events-none data-[disabled]:opacity-50', className)}
    >
      {children}
    </DropdownMenuPrimitive.Item>
  );
}

export function DropdownMenuSeparator() {
  return <DropdownMenuPrimitive.Separator className="my-1 h-px bg-border" />;
}

export function DropdownMenuLabel({ children }: { children: ReactNode }) {
  return <DropdownMenuPrimitive.Label className="px-2.5 py-1.5 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">{children}</DropdownMenuPrimitive.Label>;
}
